/*  ========================================================================
    # Scripts - Lottie Animate
    ========================================================================  */

/**
 * Script to show lottie animations
 */

import lottie from 'lottie-web';
import starsJson from '../../images/misc/stars.json';
import barrelJson from '../../images/misc/barrel.json';
import notesJson from '../../images/misc/notes.json';

const LottieAnimate = {
  cfg: {
    containers: document.querySelectorAll('div[lottie-file]')
  },

  initializeLottie() {
    this.cfg.containers.forEach(container => {
      let animationData;
      const filename = container.getAttribute('lottie-file');

      switch (filename) {
        case 'stars':
          animationData = starsJson;
          break;
        case 'barrel':
          animationData = barrelJson;
          break;
        case 'notes':
          animationData = notesJson;
          break;
        default:
          console.warn(`Lottie animation for file "${filename}" not found.`);
          return; // Skip if no matching animation is found
      }

      lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.containers) {
      this.initializeLottie();
    }
  }
};

export default LottieAnimate;
